import { render, staticRenderFns } from "./BusinessIncome.vue?vue&type=template&id=ccd17e56"
import script from "./BusinessIncome.vue?vue&type=script&lang=js"
export * from "./BusinessIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports